<nav class="mat-elevation-z2" id="main-header">
  <div>
    <img class="logo fmh img-fluid" src="assets/images/fmh_logo.png" alt="">
  </div>
</nav>
<mat-sidenav-container class="side-navigation">
  <mat-sidenav [disableClose]="false" [opened]="leftNavOpen$ | async" [mode]="mobileQuery ? 'push' : 'side'"
               class="left-menu">
    <ul class="navbar-nav">
      <li class="nav-item panel" routerLinkActive="active">
        <a routerLink="" class="nav-link"><span class="nav-link-text">Price Discovery</span></a>
      </li>
    </ul>
  </mat-sidenav>
  <mat-sidenav [disableClose]="false" [opened]="rightNavOpen$ | async" [mode]="mobileQuery ? 'push' : 'side'"
               position="end">
    <app-form-filter></app-form-filter>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar class="justify-content-end">
      <!--<button type="button" class="btn btn-outline-secondary" (click)="updateLeftNav()">
        <span class="far fa-bars"></span>
      </button>-->
      <div class="mr-auto"></div>
      <div class="btn-group">
        <button type="button" class="btn btn-outline-secondary" (click)="toggleFullScreen()" [hidden]="fullScreen">
          <span class="fal fa-expand-arrows"></span>
        </button>
        <button type="button" class="btn btn-outline-secondary" (click)="toggleFullScreen()" [hidden]="!fullScreen">
          <span class="fal fa-compress"></span>
        </button>
        <button type="button" class="btn btn-outline-secondary" (click)="updateRightNav()">
          <span class="fal fa-filter"></span>
        </button>
      </div>
    </mat-toolbar>
    <router-outlet>
    </router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
